// utils/formHandlers.js

// Handles changes to text inputs and updates the form state
export const handleInputChange = (e, setFormState) => {
    const { name, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  
  // Handles file input changes, sets the file in the form state, and creates a preview
  export const handleFileChange = (event, setFileKey, setPreviewKey, setFormState, setPreviews) => {
    const file = event.target.files[0];
    if (file) {
      setFormState((prevState) => ({
        ...prevState,
        [setFileKey]: file,
      }));
  
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreviews((prevState) => ({
          ...prevState,
          [setPreviewKey]: e.target.result,
        }));
      };
      reader.readAsDataURL(file);
    }
  };
  
  // Resets the form state and previews to their initial values
  export const resetForm = (setFormState, setPreviews) => {
    setFormState({
      trackHolder: '',
      artist: '',
      songName: '',
      recordLabel: '',
      bpm: '',
      genre: '',
      releaseDate: '',
      format: '',
      length: '',
      musicFile: null,
      imageFile: null,
    });
    setPreviews({
      musicPreview: null,
      imagePreview: null,
    });
  };
  